export default __webpack_public_path__ + "static/media/contact-us-side.9e531f82.png";